module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "panel panel-default panel-search"
  }, [_c('el-form', {
    attrs: {
      "inline": true
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "名称"
    }
  }, [_c('el-input', {
    attrs: {
      "clearable": ""
    },
    model: {
      value: (_vm.page.query.param.name),
      callback: function($$v) {
        _vm.$set(_vm.page.query.param, "name", $$v)
      },
      expression: "page.query.param.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    directives: [{
      name: "keycode",
      rawName: "v-keycode",
      value: ('ENTER'),
      expression: "'ENTER'"
    }],
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.search
    }
  }, [_vm._v("查询")])], 1)], 1)], 1), _vm._v(" "), _c('v-table', {
    ref: "table",
    attrs: {
      "page": _vm.page,
      "table-minheight": 450
    },
    on: {
      "dataloaded": _vm.onDataloaded,
      "row-dblclick": _vm.onRowDbclick
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "code",
      "label": "编码",
      "width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "名称",
      "width": "200"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "startOn",
      "label": "开始时间",
      "width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "endOn",
      "label": "结束时间",
      "width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "effectDays",
      "label": "有效期",
      "width": "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [_vm._v("\n        " + _vm._s(row.effectTimes) + " " + _vm._s(_vm.$dict.getText(row.effectTimeUnit, _vm.$dict.store.PROMOTION_EFFECT_TIMEUNIT)) + "\n      ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "visibility",
      "label": "可见性",
      "width": "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [_vm._v("\n        " + _vm._s(_vm.$dict.getText(row.visibility, _vm.$dict.store.PROMOTION_VISIBILITY)) + "\n      ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "tip",
      "label": "优惠提示"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "tip",
      "label": "总量/发放/使用",
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [_vm._v("\n        " + _vm._s(row.limitTotalNum ? row.limitTotalNum : '不限') + " / " + _vm._s((_vm.summaryMap[row.id] || {
          instanceNum: 0
        }).instanceNum) + " /  " + _vm._s((_vm.summaryMap[row.id] || {
          usedNum: 0
        }).usedNum) + "\n      ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "status",
      "label": "状态",
      "width": "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [_vm._v("\n        " + _vm._s(_vm.$dict.getText(row.status, _vm.$dict.store.PROMOTION_STATUS)) + "\n      ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "createOn",
      "width": "140",
      "label": "创建时间"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [_vm._v("\n        " + _vm._s(row.createOn) + "\n      ")]
      }
    }])
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-df013820","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/app/act/promotionInfo/Search.vue
// module id = 356
// module chunks = 0